import React, { useEffect } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { Browser } from '@capacitor/browser';

interface MandatoryUpdateScreenProps {
    storeUrl: string;
}

/**
 * Pantalla completa de Actualización Obligatoria.
 * No se puede cerrar con botón Atrás de Android, ni arrastrando, ni con una "X".
 * Contiene el logo, título "Actualización requerida", texto informativo y botón principal azul "Actualizar".
 */
export const MandatoryUpdateScreen: React.FC<MandatoryUpdateScreenProps> = ({ storeUrl }) => {
    // Interceptar y bloquear botón Atrás de Android de forma incondicional
    useEffect(() => {
        let handle: any = null;
        try {
            CapacitorApp.addListener('backButton', () => {
                // Bloqueado: la actualización es obligatoria y no permite retroceso
            }).then(h => {
                handle = h;
            });
        } catch (e) {
            // Ignorado en entorno web
        }

        return () => {
            if (handle && typeof handle.remove === 'function') {
                handle.remove();
            }
        };
    }, []);

    const handleUpdate = async () => {
        const targetUrl = storeUrl || 'https://play.google.com/store/apps/details?id=cl.ldconstructora.klydapp';
        try {
            await Browser.open({ url: targetUrl });
        } catch (e) {
            window.open(targetUrl, '_system');
        }
    };

    return (
        <div
            data-mandatory-update-screen="true"
            className="fixed inset-0 z-[999999] flex flex-col items-center justify-center p-6 bg-white dark:bg-[#0F172A] text-slate-800 dark:text-slate-100 select-none"
            style={{
                paddingTop: 'calc(1.5rem + var(--kl-safe-top, env(safe-area-inset-top, 0px)))',
                paddingBottom: 'calc(1.5rem + var(--kl-safe-bottom, env(safe-area-inset-bottom, 0px)))'
            }}
        >
            <div className="flex flex-col items-center text-center max-w-xs w-full my-auto">
                {/* Logo */}
                <div className="size-20 rounded-2xl bg-white dark:bg-slate-800 shadow-md border border-slate-200/80 dark:border-slate-700 p-2 flex items-center justify-center mb-6">
                    <img
                        src="/assets/play_store_icon.png"
                        alt="K-LyDapp"
                        className="w-full h-full object-contain rounded-xl"
                    />
                </div>

                {/* Título */}
                <h1 className="text-xl font-bold text-slate-900 dark:text-white mb-2 tracking-tight">
                    Actualización requerida
                </h1>

                {/* Mensaje descriptivo */}
                <p className="text-sm text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
                    Hay una nueva versión de K-LyDapp. Actualiza para seguir usándola.
                </p>

                {/* Botón Principal Azul */}
                <button
                    type="button"
                    onClick={handleUpdate}
                    className="w-full h-12 bg-blue-600 hover:bg-blue-700 active:scale-[0.98] text-white font-bold text-base rounded-xl shadow-md transition-all flex items-center justify-center cursor-pointer"
                >
                    Actualizar
                </button>
            </div>
        </div>
    );
};

export default MandatoryUpdateScreen;
